// src/hooks/useLoadFollows.js
"use client";

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFollowedDoctorsThunk } from "../redux/thunks/followsThunks";

export default function useLoadFollows() {
  const dispatch = useDispatch();

  // ✅ Obtenir l'ID utilisateur directement sans selectCurrentActor
  const currentUserId = useSelector((s) => {
    return s.auth?.user?.id || s.auth?.user?._id || s.user?.id || s.user?._id;
  });

  const isAuthenticated = useSelector((s) => s.auth?.isAuthenticated) || !!currentUserId;
  const loaded = useSelector((s) => !!s.follows?.loaded);
  const loading = useSelector((s) => !!s.follows?.loading);

  const onceRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !currentUserId) return;
    if (loaded || loading) return;
    if (onceRef.current) return;

    onceRef.current = true;

    dispatch(getFollowedDoctorsThunk({ followerId: String(currentUserId) }));
  }, [dispatch, currentUserId, isAuthenticated, loaded, loading]);
}